import type { McReviewQueueRow } from 'src/interfaces/mcDocumentReview'
import type { State } from '../reducers/types'

/** Returns the stored array by reference — see the note in selectors/documentReview.ts. */
export const getMcReviewDocuments = (state: State): McReviewQueueRow[] => {
  return state.mcDocumentReview.documents
}

export const getMcReviewDocumentsLoading = (state: State): boolean => {
  return state.mcDocumentReview.documentsLoading
}

export const getMcReviewDocumentsError = (state: State): string | null => {
  return state.mcDocumentReview.documentsError
}

export const getMcDocumentReviewSubmitting = (state: State): boolean => {
  return state.mcDocumentReview.submitting
}
